import { MealCreditUpdatePayload } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { sdk } from 'src/utilities/sdk';

export interface UpdateMealCreditApiProps {
  corpId: string;
  mealCreditPayload: MealCreditUpdatePayload;
}

export const updateMealCreditApi = async ({
  corpId,
  mealCreditPayload,
}: UpdateMealCreditApiProps): Promise<void> => {
  return sdk.http.put(`/corps/${corpId}/eventmetadata`, mealCreditPayload);
};
